// Dashboard mirror of utils/orderRiderLock.js on the server. The server is the
// boundary and refuses these writes with 409 ORDER_NOT_ASSIGNABLE; this copy
// only stops the dashboard from offering a control that can never work.
// Change both lists together.

export const RIDER_LOCKED_DELIVERY_STATES = Object.freeze([
  "DELIVERED",
  "FULFILLED",
  "NOT_APPLICABLE",
  "REJECTED",
  "CANCELLED",
  "CANCELED",
]);

/** The locked state ("DELIVERED", "CANCELLED", ...) or null when assignable. */
export function riderLockState(order) {
  if (!order) return null;
  const status = String(order.delivery_status || "").toUpperCase();
  if (RIDER_LOCKED_DELIVERY_STATES.includes(status)) return status;
  if (order.isDelivered === true) return "DELIVERED";
  if (order.cancellation?.cancelledAt) return "CANCELLED";
  return null;
}

export const isRiderAssignmentLocked = (order) => riderLockState(order) !== null;

export function riderLockMessage(state) {
  switch (state) {
    case "DELIVERED":
    case "FULFILLED":
    case "NOT_APPLICABLE":
      return "This order is complete, so the rider can no longer be assigned or changed.";
    case "REJECTED":
      return "This order was rejected, so it cannot be assigned to a rider.";
    default:
      return "This order was cancelled, so it cannot be assigned to a rider.";
  }
}
